import React, { useEffect, useRef, useState, useTransition } from 'react'
import dateFormat from "dateformat";
import { createChart } from "lightweight-charts";








const Demo = () => {




    const [currentTimeFrame, updateTimeFrame] = useState({
        period: "1",
        period_type: "minute",
        limit: 1000,
        day: 2,
        activeclass: "1m",
    });
    const [isPending, startTransition] = useTransition();
    const getLivePrice = useRef(null);
    const chartContainerRef = useRef();
    var chart = useRef(null);
    var newSeries = useRef(null);














    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        fetch(`https://api.wlffinance.org/api/user/new/coin//test/candle/view`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data?.data);



                const resultsData = data?.data;
                //   const sort = resultsData.sort((a, b) => (a.t > b.t ? 1 : -1));
                const candles = resultsData.map((d) => ({
                    time: d?.time / 1000,
                    open: Number(parseFloat(d?.open).toFixed(2)),
                    high: Number(parseFloat(d?.high).toFixed(2)),
                    low: Number(parseFloat(d?.low).toFixed(2)),
                    close: Number(parseFloat(d?.close).toFixed(2)),
                }));
                // console.log(resultsData)
                newSeries.current.setData(candles)
                setLoading(false);
            });
    }, []);

    //   console.log(data[data.length-1]);
    //   console.log(parseInt(data[data.length-1]?.time));

    const [liveData, setLiveData] = useState([]);


    useEffect(() => {
        const interval = setInterval(() => {
            fetchData();
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const fetchData = async () => {
        fetch(
            `https://api.wlffinance.org/api/user/new/coin//test/candle/live/view`,
            {
                method: "GET",
            }
        )
            .then((res) => res.json())
            .then((data) => {
                setLiveData(data?.data);

                var liveData = data?.data;
                var editLiveData = {
                    time: liveData?.time / 1000,
                    open: Number(parseFloat(liveData?.open).toFixed(2)),
                    high: Number(parseFloat(liveData?.high).toFixed(2)),
                    low: Number( parseFloat(liveData?.low).toFixed(2)),
                    close: Number(parseFloat(liveData?.close).toFixed(2)),
                };
                getLivePrice.current = editLiveData.close;
                newSeries.current.update(editLiveData);

            });
    };

    const chartOptions = {
        layout: {
            textColor: "white",
            background: { type: "solid", color: "rgb(11, 6, 25)" },
        },
        grid: {
            vertLines: {
                color: "transparent",
            },
            horzLines: {
                color: "transparent",
            },
        },
        width: chartContainerRef.current && chartContainerRef.current.offsetWidth,
        height: window.innerWidth / 1.5,
    };

    useEffect(() => {
        chart.current = createChart(chartContainerRef.current, chartOptions);
        newSeries.current = chart.current.addCandlestickSeries({
            upColor: "#26a69a",
            downColor: "#ef5350",
            borderVisible: false,
            wickUpColor: "#26a69a",
            wickDownColor: "#ef5350",
        });

        // chart.current.timeScale().fitContent();
        chart.current.timeScale().scrollToPosition(5);

        chart.current.timeScale().applyOptions({
            rightOffset: 5,
            barSpacing: 10,
            minBarSpacing: 5,
            fixLeftEdge: true,
            borderVisible: false,
            timeVisible: true,
            tickMarkFormatter: (time, tickMarkType, locale) => {
                const date = new Date(parseFloat(time) * 1000);
                const timeFormatter = new Intl.DateTimeFormat(locale, {
                    hour12: true,
                    hour: "numeric",
                    minute: "numeric",
                });
                return timeFormatter.format(date);
            },
        });

        // Apply the custom priceFormatter to the chart
        chart.current.applyOptions({
            localization: {
                priceFormatter: (price) => price,
            },
        });

        return () => [chart.current.remove()];
    }, []);


    //  //update price chart
    //   useEffect(() => {
    //     const conn = new WebSocket(GetLiveCandle());
    //     //taken fron priceData.js
    //     startTransition(() => {
    //       conn.onopen = () => {
    //         conn.send(
    //           JSON.stringify({
    //             action: "auth",
    //             params: `${process.env.REACT_APP_POLYGON_API_KEY}`,
    //           })
    //         );
    //       };

    //       conn.onmessage = function (event) {
    //         const data = JSON.parse(event.data)[0];
    //         if (data?.status === "auth_success") {
    //           conn.send(
    //             JSON.stringify({
    //               action: "subscribe",
    //               params: `XAS.${cryptoCoinSymbol}-${cryptoCoincurrency}`,
    //             })
    //           );
    //         }

    //         if (data?.ev === "XAS") {
    //           GetAgre(currentTimeFrame, cryptoCoin).then((Resp) => {
    //             const resultsData = Resp?.data?.results;
    //             if (resultsData) {
    //               var liveData = data;
    //               var editLiveData = {
    //                 time: resultsData[0].t / 1000,
    //                 open: resultsData[0].o ,
    //                 high: parseFloat(liveData?.h) ,
    //                 low: parseFloat(liveData?.l) ,
    //                 close: parseFloat(liveData?.c) ,
    //               };
    //               getLivePrice.current = editLiveData.close;
    //               newSeries.current.update(editLiveData);
    //               setLiveDataShow(liveData);
    //             }
    //           });
    //         }
    //       };
    //       //taken fron priceData.js
    //       GetCandles(currentTimeFrame, cryptoCoin).then((Resp) => {
    //           const resultsData = Resp?.data?.results;
    //           const sort = resultsData.sort((a, b) => (a.t > b.t ? 1 : -1));
    //           const candles = sort.map((d) => ({
    //             time: d?.t / 1000,
    //             open: parseFloat(d?.o) ,
    //             high: parseFloat(d?.h) ,
    //             low: parseFloat(d?.l) ,
    //             close: parseFloat(d?.c) ,
    //           }));
    //           //As web scoket is delayed by 2 seconds, im setting live price to last candle open price
    //           getLivePrice.current = updateAdminPrice
    //           ? resultsData[resultsData.length - 1].c 
    //           : 0.0;
    //           setLiveDataShow(resultsData[resultsData.length - 1]);
    //           newSeries.current.setData(candles);
    //       });
    //     });

    //     return () => {
    //       conn.close();
    //     };
    //   }, [
    //     currentTimeFrame,
    //     cryptoCoin,
    //     updateAdminPrice,
    //     cryptoCoinSymbol,
    //     cryptoCoincurrency,
    //   ]);

    return (
        <>

            <h1 className='py-5 d-flex justify-centent-center'>Demo</h1>


            <div className='p-5 m-5'>
                <div className="candle-time-framer">
                    <p
                        className={
                            currentTimeFrame?.activeclass === "1m" ? "active" : ""
                        }
                        onClick={() =>
                            updateTimeFrame({
                                period: "1",
                                period_type: "minute",
                                limit: 1000,
                                day: 2,
                                activeclass: "1m",
                            })
                        }
                    >
                        1m
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "5m" ? "active" : ""
                        }
                        onClick={() =>
                            updateTimeFrame({
                                period: "5",
                                period_type: "minute",
                                limit: 10000,
                                day: 2,
                                activeclass: "5m",
                            })
                        }
                    >
                        5m
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "15m" ? "active" : ""
                        }
                        onClick={() =>
                            updateTimeFrame({
                                period: "15",
                                period_type: "minute",
                                limit: 10000,
                                day: 10,
                                activeclass: "15m",
                            })
                        }
                    >
                        15m
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "30m" ? "active" : ""
                        }
                        onClick={() =>
                            updateTimeFrame({
                                period: "30",
                                period_type: "minute",
                                limit: 50000,
                                day: 30,
                                activeclass: "30m",
                            })
                        }
                    >
                        30m
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "1h" ? "active" : ""
                        }
                        onClick={() =>
                            updateTimeFrame({
                                period: "1",
                                period_type: "hour",
                                limit: 50000,
                                day: 365,
                                activeclass: "1h",
                            })
                        }
                    >
                        1h
                    </p>
                    <p
                        className={
                            currentTimeFrame?.activeclass === "1d" ? "active" : ""
                        }
                        onClick={() =>
                            updateTimeFrame({
                                period: "1",
                                period_type: "day",
                                limit: 50000,
                                day: 365,
                                activeclass: "1d",
                            })
                        }
                    >
                        1d
                    </p>
                </div>
                <div className="user-live-data-show">
                    <div className="user-live-data">
                        <p>
                            Time:{" "}
                            {liveData?.time &&
                                dateFormat(
                                    parseFloat(liveData?.time),
                                    "yyyy-mm-dd h:MM TT"
                                )}
                        </p>
                        <p>Open: {liveData?.open && parseFloat(liveData?.open)}</p>
                        <p>High: {liveData?.high && parseFloat(liveData?.high)}</p>
                        <p>Low: {liveData?.low && parseFloat(liveData?.low)}</p>
                    </div>
                    <div className="user-live-data">
                        <p>Close: {liveData?.close && parseFloat(liveData?.close)}</p>
                        {/* <p>Volume: {liveData?.v && parseFloat(liveData?.v)}</p> */}
                    </div>
                </div>
                <div
                    ref={chartContainerRef}
                    style={{
                        width: "100%",
                        height: "100%",
                    }}
                ></div>
            </div>

        </>
    )
}

export default Demo;